import { render, staticRenderFns } from "./DialogCustomPrompt.vue?vue&type=template&id=3479f0e4"
import script from "./DialogCustomPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCustomPrompt.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports